import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Loop"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.6925 14.5575L19.5 16.5H15.75V18H19.5L17.6925 19.9425L18.75 21L22.5 17.25L18.75 13.5L17.6925 14.5575ZM9.75 4.5C7.25983 4.50092 4.97243 5.87278 3.79896 8.06912C2.62549 10.2655 2.75657 12.9295 4.14 15L5.385 14.1675C4.04672 12.1654 4.24221 9.50948 5.85921 7.72487C7.47621 5.94027 10.1 5.48465 12.224 6.61963C14.348 7.75461 15.4274 10.1891 14.8425 12.5252C14.2575 14.8613 12.1582 16.4999 9.75 16.5H1.5V18H9.75C13.4779 18 16.5 14.9779 16.5 11.25C16.5 7.52208 13.4779 4.5 9.75 4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Loop.vue"]]);
